export async function sleep(ms: number) {
  return await new Promise((resolve) => setTimeout(resolve, ms))
}

export function generateNumberFromDate(max: number, date: string): number {
  if (max <= 0) {
    throw new Error('"max" must be a positive number')
  }

  if (!/^\d{4}-\d{2}-\d{2}$/.test(date)) {
    throw new Error('"date" has incorrect format. It must be: YYYY-MM-DD.')
  }

  const dateObj = new Date(date)

  if (isNaN(dateObj.getTime())) {
    throw new Error('Invalid "date"')
  }

  const timestamp = dateObj.getTime()
  const randomSeed = ((timestamp % 2147483647) * 16807) % 2147483647
  const result = randomSeed % max

  return result
}
